export default function SearchIcon({ width = 24, height = 24 }: { width?: number; height?: number }) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd" stroke="#000" strokeLinejoin="bevel" strokeWidth="1.5">
    <path d="M20 6.5H4M9.135 11.461H4M21.442 19.976l-3.483-3.588M19 13.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z"></path>
    </g>
  </svg>;
}